module.exports = __webpack_public_path__ + "static/fulla-moda-case-study-e24ae3dd86a1f5bc541e4eab59fec3c9.webp";